import AnnouncementDesigner from '@admin/components/announcement_designer'
import ModalPanel from '@admin/components/modal_panel'
import PropTypes from 'prop-types'
import React from 'react'

class Design extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    modal: PropTypes.object
  }

  static propTypes = {
    onBack: PropTypes.func,
    onNext: PropTypes.func
  }

  state = {
    config: {}
  }

  _handleBack = this._handleBack.bind(this)
  _handleNext = this._handleNext.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <AnnouncementDesigner { ...this._getAnnouncementDesigner() } />
      </ModalPanel>
    )
  }

  _getAnnouncementDesigner() {
    return {
      onChange: this._handleUpdate
    }
  }

  _getPanel() {
    return {
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Next)', color: 'blue', handler: this._handleNext }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleNext() {
    const { config } = this.state
    this.props.onNext({ config })
  }

  _handleUpdate(config) {
    this.setState({ config })
  }

}

export default Design
